/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { userStyles } from 'consts/styles/User';
import Tooltip from '@material-ui/core/Tooltip';
import Icons from 'consts/icons';
import ComponentSettingsDetails from './MainSettings/ComponentSettingsDetails';

const ComponentSettings = props => {
  const { details, setDetails, items, toggleModal } = props;

  const [renderedMenuItem, setRenderedMenuItem] = React.useState(null);

  const classesUser = userStyles();

  const subtitles = useSelector(state => state.language).close_;

  React.useEffect(() => {
    if (details) setRenderedMenuItem(details);
  }, [details]);

  React.useEffect(() => {
    if (details !== renderedMenuItem) setDetails(renderedMenuItem);
  }, [renderedMenuItem]);

  return (
    <div className={classesUser.User}>
      <div className={`${classesUser.User}__settings`}>
        <main className={`${classesUser.User}__settings__content`}>
          <div className={`${classesUser.User}__settings__content__spacer`} />
          <Container>
            <Tooltip title={subtitles} placement="bottom">
              <div
                className={`${classesUser.User}__settings__close`}
                onClick={toggleModal}
                onKeyPress={toggleModal}
                role="button"
                tabIndex={0}
              >
                <div
                  className={`${classesUser.User}__settings__close__container`}
                >
                  <Icons.Actions.Close />
                </div>
              </div>
            </Tooltip>
            <ComponentSettingsDetails
              renderedMenuItem={renderedMenuItem}
              items={items}
            />
          </Container>
          <div className={`${classesUser.User}__settings__content__spacer`} />
        </main>
      </div>
    </div>
  );
};
ComponentSettings.propTypes = {
  details: PropTypes.string,
  setDetails: PropTypes.func,
  toggleModal: PropTypes.func,
  items: PropTypes.array,
};
const ExportedComponentSettings = React.forwardRef((props, ref) => (
  <ComponentSettings {...props} {...ref} />
));

export default ExportedComponentSettings;
